import React from "react";
import { useNavigate } from "react-router-dom";
import "../App.css";

export default function PaymentSuccessPage() {
  const navigate = useNavigate();

  return (
    <div style={pageContainer}>
      <div style={cardStyle}>
        <h1 style={titleStyle}>Payment Successful 🎉</h1>
        <p style={messageStyle}>
          Your payment has been processed successfully. Your credits are now available in your account.
        </p>
        <button
          onClick={() => navigate("/dashboard")}
          className="primary-button"
          style={{ marginTop: "20px", width: "200px" }}
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
}

const pageContainer = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
  backgroundColor: "#f2f6fc",
};

const cardStyle = {
  backgroundColor: "#fff",
  borderRadius: "8px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
  padding: "30px",
  textAlign: "center",
  maxWidth: "400px",
};

const titleStyle = {
  fontSize: "1.8rem",
  color: "#16a34a",
  marginBottom: "15px",
};

const messageStyle = {
  fontSize: "1rem",
  color: "#374151",
};
